import * as utils from '#packages/util';

import type { Link } from '@wix/document-services-types';

let LATEST_COPIED_LINKS: AnyFixMe = {};

function createUrlLink(url: string) {
  return {
    type: 'ExternalLink',
    target: '_blank',
    url,
  };
}

function tryCreateMailLink(href: string) {
  if (!/^mailto:/i.test(href)) {
    return null;
  }
  const hrefArr = href.replace(/mailto:/i, '').split('?');
  if (!utils.validationExpressions.validEmailReg.test(hrefArr[0])) {
    return null;
  }
  const emailAddress = hrefArr[0];
  let subject = hrefArr[1];
  if (/^subject=/i.test(subject)) {
    subject = subject.replace(/^subject=/i, '');
  } else {
    subject = '';
  }
  return {
    type: 'EmailLink',
    recipient: emailAddress,
    subject,
  };
}

export interface LinksHelperType {
  getLink(linkId: string): Link;
  setNonPasteableLinkTypes(nonPasteableLinkTypes: string[]): void;

  getAllLinks(): Link[];

  setCurrentLinks(links: Link[]): void;
}

export class LinksHelper implements LinksHelperType {
  private _links: Record<string, Link>;
  private nonPasteableLinkTypes: AnyFixMe;

  constructor(initialLinks: AnyFixMe, nonPasteableLinkTypes?: AnyFixMe) {
    this.setCurrentLinks(initialLinks);
    this.setNonPasteableLinkTypes(nonPasteableLinkTypes ?? []);
  }

  getLink(linkId: string): Link {
    return this._links[linkId];
  }

  setNonPasteableLinkTypes(nonPasteableLinkTypes: AnyFixMe) {
    this.nonPasteableLinkTypes = nonPasteableLinkTypes;
  }

  getAllLinks(): Link[] {
    return Object.values(this._links);
  }

  setCurrentLinks(links: Link[]) {
    this._links = {};

    links?.forEach((link: Link) => {
      this._links[link.id] = link;
    });
  }

  cacheCopiedLinks() {
    LATEST_COPIED_LINKS = structuredClone(this._links);
  }

  createLinkFromHref(href: string) {
    let linkData = {};

    const isValidUrl = utils.validationExpressions.validUrlReg.test(href);
    if (isValidUrl) {
      linkData = createUrlLink(href);
    } else {
      linkData = tryCreateMailLink(href);
    }

    if (linkData) {
      return this.saveLink(linkData);
    }

    return null;
  }

  saveLink(linkObj: AnyFixMe) {
    linkObj.id = utils.guidUtils.getUniqueId('textLink', '_');

    this._links[linkObj.id] = linkObj;

    return linkObj.id;
  }

  getLatestCopiedLink(linkId: string) {
    const currLink = LATEST_COPIED_LINKS[linkId];
    if (currLink && !this.nonPasteableLinkTypes.includes(currLink.type)) {
      return currLink;
    }
    return null;
  }

  duplicateLink(linkId: string) {
    const currLink = this.getLink(linkId) || this.getLatestCopiedLink(linkId);

    if (currLink) {
      return this.saveLink(structuredClone(currLink));
    }

    return null;
  }
}
